export default "__VITE_ASSET__ede529b5__"